// import { FaPaintBrush, FaFill, FaEraser, FaTrash } from 'react-icons/fa';
import { PaintbrushIcon, EraserIcon, TrashIcon, PenIcon} from 'lucide-react'
import { Tool } from '../../types/mspaints.tsx';
import { ColorPicker } from './ColorPicker';

interface ToolbarProps {
    tool: Tool;
    color: string;
    speed: number;
    onToolChange: (tool: Tool) => void;
    onColorChange: (color: string) => void;
    onSpeedChange: (speed: number) => void;
    onClear: () => void;
}

export function Toolbar({
                            tool,
                            color,
                            speed,
                            onToolChange,
                            onColorChange,
                            onSpeedChange,
                            onClear
                        }: ToolbarProps) {
    const tools: { type: Tool; icon: React.ReactNode; label: string }[] = [
        { type: 'brush', icon: <PaintbrushIcon />, label: 'Brush' },
        { type: 'fill', icon: <PenIcon />, label: 'Fill' },
        { type: 'eraser', icon: <EraserIcon />, label: 'Eraser' },
    ];


    return (
        <div className="flex flex-wrap gap-4 mb-4 items-center">
            {tools.map(({ type, icon, label }) => (
                <button
                    key={type}
                    className={`p-2 rounded flex items-center gap-2 ${
                        tool === type ? 'bg-blue-500 text-white' : 'bg-gray-200'
                    }`}
                    onClick={() => onToolChange(type)}
                >
                    {icon} {label}
                </button>
            ))}
            <ColorPicker color={color} onChange={onColorChange} />
            <div className="flex items-center gap-2">
                <span className="text-sm font-medium">Speed:</span>
                <input
                    type="range"
                    min="0.1"
                    max="1"
                    step="0.1"
                    value={speed}
                    onChange={(e) => onSpeedChange(parseFloat(e.target.value))}
                    className="w-32"
                />
                <span className="text-sm">{Math.round(speed * 100)}%</span>
            </div>
            <button
                className="p-2 rounded bg-red-500 text-white flex items-center gap-2"
                onClick={onClear}
            >
                <TrashIcon /> Clear Canvas
            </button>
        </div>
    );
}
